import React,{useState,useEffect} from 'react';
//import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
//import MenuItem from '@mui/material/MenuItem';
//import {useStyles} from './useStyles';
import {Tools} from './Tools';
import {Dataset} from './Inc';

interface InputNumberProps {
	label:string,
	value:number,
	required:boolean,
	list?: Dataset[],
	helper?:string,
	onChange(value:number,hasError:boolean):void,
	opt?:{[key:string]:any;},
}

const InputNumber:React.FC<InputNumberProps> = (props)=> {
	const [states,setStates] = useState({
		value: String(props.value),
		error: '',
	})
    const blur = ()=>{
		let value = 0;
		if(parseInt(states.value)){
			value = parseInt(states.value);
		}
		props.onChange(value,states.error!=='');
    }
	const change = (event: React.ChangeEvent<HTMLInputElement>) => {
		let value = Tools.toHan(event.target.value);
		validate(value);
	}
	const validate = (value:string)=>{
		let error = '';
		if( value==='' ){
			if( props.required ){
				error = props.label +  'を入力してください'
			}
		} else {
			const num = parseInt(value)
			if( num || num===0 ){
				if( props.opt ){
					if( props.opt["minValue"] ){
						if( num<props.opt["minValue"] ){
							error  = props.label + 'は'+Tools.comma(props.opt["minValue"])+'以上にしてください';
						}
					}
					if( props.opt["maxValue"] ){
						if( num>props.opt["maxValue"] ){
							error = props.label + 'は'+Tools.comma(props.opt["maxValue"])+'以内にしてください';
						}				
					}
				}
				value = String(num);
			} else {
				value = '';
			}
		}
		setStates({value:value,error:error});
	}

	let rows:number = 1;
	if( props.opt && props.opt["rows"] ){
		rows = props.opt["rows"];
	}
	let type:"text"|"time" = "text";
	if( props.opt && props.opt["type"] ){
		type = props.opt["type"];
	}

	let inputLabelProps:any = {};
	let inputProps:any = {};
	let placeholder = "";
	let required = false;
	//let maxLength = 0;
	//let rest = 0;
	//let classCounter = "formCounter";
	let fullWidth = true;
	let disabled = false;
	if( props.opt ){
		if( props.opt["shrink"]===true ){
			inputLabelProps["shrink"] = true;
		}
		if( props.opt["startAdornment"] ){
			inputProps["startAdornment"] = <InputAdornment position='start' style={{whiteSpace:'nowrap',marginRight:'1em'}}>{props.opt["startAdornment"]}</InputAdornment>;
		}
		if( props.opt["endAdornment"] ){
			//inputProps["endAdornment"] = props.opt["endAdornment"];
			inputProps["endAdornment"] = <InputAdornment position='end' style={{whiteSpace:'nowrap'}}>{props.opt["endAdornment"]}</InputAdornment>;
		}
		if( props.opt["placeholder"] ){
			placeholder = props.opt["placeholder"];
		}
		if( props.opt["required"] ){
			required = props.opt["required"];
		}
		if( props.opt["fullWidth"]===false ){
			fullWidth = false;
		}
		if( props.opt["disabled"]===true ){
			disabled = true;
		}
	}
	//inputProps["className"] = "formInput";

	let helper = '';
	if(states.error!==''){
		helper = states.error;
	} else if( props.helper ){
		helper = props.helper;
	}


	useEffect(()=>{
		setStates({
			value: String(props.value),
			error: '',
		});
	},[props.value])

	return (
		<FormControl fullWidth={fullWidth}>
			<TextField
				label={props.label}
				variant="filled"
				onChange = {change}
				value={states.value}
				error={states.error!==''}
				helperText={helper}
				placeholder={placeholder}
				rows={rows}
				required={required}
				multiline={rows>1}
				InputLabelProps = {inputLabelProps}
				InputProps = {inputProps}
				type={type}
				disabled={disabled}
				onBlur={blur}
			/>
		</FormControl>
	);	
}

export default InputNumber;